import React from "react";
import { Helmet } from "react-helmet";
import contentStore from "~/content";

const content = contentStore.global.seo;

export const SiteHelmet = () => {
  const title = content.title;
  const description = content.description;
  const url = content.url;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />

      {/* Social */}
      {/* TODO: Add social images */}
      <meta property="og:title" content={title} />
      <meta property="og:type" content="website" />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content={title} />
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  );
};
